module["exports"] = ["MBA", "Phd."];